import { defineMessages } from 'react-intl';

export default defineMessages({
  compareAction: {
    id: 'frontbucket.repository.commits.compareAction',
    description: 'Action to navigate to the compare page.',
    defaultMessage: 'Compare',
  },
});
